/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Confirm_EnInputs */

const cs_property_ai_confirm_en = /** @type {(inputs: Property_Ai_Confirm_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit EN překlad`)
};

const en_property_ai_confirm_en = /** @type {(inputs: Property_Ai_Confirm_EnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm EN translation`)
};

/**
* | output |
* | --- |
* | "Confirm EN translation" |
*
* @param {Property_Ai_Confirm_EnInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_confirm_en = /** @type {((inputs?: Property_Ai_Confirm_EnInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Confirm_EnInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_confirm_en(inputs)
	return cs_property_ai_confirm_en(inputs)
});